import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {showNativeTaskModal} from '../../../graphql/forecastRelay';

/**
 * ACC-527: bridge from the ticketing island to the native Forecast task detail
 * modal (`task_modal_v3`). `showNativeTaskModal` (a forecastRelay seam over
 * `Util.showTaskModal`) appends `/T{companyTaskId}` to the current pathname; the
 * global `OpenTaskModal` route (mounted outside web-front's main <Switch> in
 * routerv2.js) then overlays the native modal on top of the current `/tickets/...`
 * page. We pass the island's react-router v5 history so the push happens inside
 * the shared router the island already runs on. Going through the seam keeps the
 * island's single `Util` touchpoint isolated (and mockable) in forecastRelay.
 */
export function useOpenNativeTaskModal(): (companyTaskId: number) => void {
	const history = useHistory();
	return useCallback(
		(companyTaskId: number) => {
			if (companyTaskId == null || Number.isNaN(companyTaskId)) return;
			showNativeTaskModal(companyTaskId, history);
		},
		[history]
	);
}
